// extracted by mini-css-extract-plugin
export default {"questionnaireListItemContainer":"QuestionnaireListItem_questionnaireListItemContainer__WQdDE"};